import React from "react";
import { Link } from "react-router-dom";
import { ABOUT_PAGE } from "../../content/siteContent";

export const AboutEleven = () => {
  return (
    <section className="about-area-eleven">
      <div className="container">
        <div className="row align-items-center justify-content-center">
          <div className="col-lg-6 col-md-9 order-0 order-lg-2">
            <div className="about-img-wrap-eleven">
              <img src="/images/home/red_ball.png"  alt="" />
              <img src="/images/home/dots.png" alt="" className="shape-one" />
              <img src="/images/home/team-consultation.webp" alt="Zawix Business Consultants team reviewing client documents" className="shape-two" />
            </div>
          </div>

          <div className="col-lg-6">
            <div className="about-content-eleven">
              <div className="section-title mb-30">
                <span className="sub-title">About Zawix Business Consultants</span>
                <h2 className="title">
                  Trusted consultancy support for <br />
                  businesses across Pakistan
                </h2>
              </div>

              <p>{ABOUT_PAGE.intro}</p>
              <p>{ABOUT_PAGE.introTwo}</p>

              <div className="about-list-two">
                <ul className="list-wrap">
                  {ABOUT_PAGE.whyChoose.slice(0, 3).map((item) => (
                    <li key={item}>
                      <i className="fas fa-arrow-right"></i>
                      {item}
                    </li>
                  ))}
                </ul>
              </div>

              <Link to="/services" className="btn btn-three">
                Our Services
              </Link>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
